import { makeAutoObservable } from "mobx";
import { isValidCognitoUsername, isValidEmail, isValidPassword } from "@/util/validators";

export type UnknownUserData = {
  email?: string;
  password?: string;
  name?: string;
  registrationCode?: string;
};

export class UnknownUser {
  public email?: string;
  public password?: string;
  public passwordAgain?: string;
  public passwordResetCode?: string;
  public name?: string;
  public registrationCode?: string;

  constructor(data?: UnknownUserData) {
    if (data) {
      this.email = data.email;
      this.password = data.password;
      this.name = data.name;
      this.registrationCode = data.registrationCode;
    }
    makeAutoObservable(this);
  }

  public get isEmailValid() {
    return this.email?.length ? isValidEmail(this.email) : true;
  }

  public get isPasswordEntered() {
    return (this.password?.length || 0) > 0;
  }

  public get isPasswordValid() {
    return this.isPasswordEntered && isValidPassword(this.password ?? "");
  }

  public get arePassowrdsMatching() {
    return this.password === this.passwordAgain;
  }

  public get isPasswordAgainValid() {
    return this.isPasswordValid && this.arePassowrdsMatching;
  }

  public get isUsernameValid() {
    return this.name?.length ? isValidCognitoUsername(this.name) : true;
  }

  public get canLogin() {
    return this.email?.length && this.isEmailValid && this.isPasswordEntered;
  }

  public get canResetPassword() {
    return this.email?.length && this.isEmailValid;
  }

  public get canSignup() {
    console.log(
      "UnknownUser.canSignup()",
      this.email?.length,
      this.isEmailValid,
      this.isPasswordEntered,
      this.isPasswordValid,
    );
    return !!(this.email?.length && this.isEmailValid) && !!(this.isPasswordEntered && this.isPasswordValid);
  }

  public get canCreateNewPassword() {
    return this.isPasswordValid && this.arePassowrdsMatching;
  }
}
